"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundManager = void 0;
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const GameState_1 = require("./GameState");
const GameConfig_1 = require("./GameConfig");
const AudioCtx_1 = require("../Common/AudioCtx");
const Utils_1 = require("../Utils/Utils");
let SoundManager = class SoundManager {
    constructor(resources, state, config, events) {
        this.state = state;
        const sounds = {
            perfect: resources.perfect.data,
            great: resources.great.data,
            good: resources.good.data,
            flick: resources.flick.data,
            button: resources.button.data,
        };
        for (const prop in sounds) {
            sounds[prop].volume = config.effectVolume;
        }
        const toStop = new Set();
        const play = (s, delay) => {
            if (!(s in sounds))
                return;
            const au = new AudioCtx_1.AudioInstance(sounds[s]);
            if (!au) {
                console.warn("No such sound named " + s);
                return;
            }
            au.onend.add(() => toStop.delete(au));
            au.play(delay);
            toStop.add(au);
        };
        state.on.soundEffect.add((remove, type, delay) => {
            if (state.ended)
                return remove();
            play(type, delay);
        });
        const clear = () => {
            const list = Utils_1.setItems(toStop);
            for (const au of list)
                au.stop();
            toStop.clear();
        };
        state.on.pause.add(clear);
        state.on.emptyTap.add(remove => {
            if (state.ended)
                return remove();
            play("button", 0);
        });
        events.End.add(clear);
    }
};
SoundManager = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, GameState_1.GameState, GameConfig_1.GameConfig, SymbolClasses_1.GlobalEvents])
], SoundManager);
exports.SoundManager = SoundManager;
//# sourceMappingURL=SoundManager.js.map